import {
    Directive,
    Optional,
    ElementRef,
    Inject,
    Self,
    ChangeDetectorRef,
    HostListener, AfterViewInit
} from '@angular/core';

import { TIME_MERIDIEM } from '../interfaces/Tokens';
import { NgControl } from '@angular/forms';
import { PickerAbstract } from './picker';

@Directive({
    selector: 'anj-input[anjDatetimePicker]',
    exportAs: 'anjDatetimePickerInput'
})
export class DatetimePickerDirective extends PickerAbstract implements AfterViewInit {
    @HostListener('anjBlur')
    onAnjBlur() {
        this.onTouch();
    }

    @HostListener('anjDatetimeChange', ['$event'])
    public onAnjDatetimeChange(event: any) {
        this.changeHandler(event.detail);
    }

    constructor(_element: ElementRef,
                changeRef: ChangeDetectorRef,
                @Optional() @Self() ngControl?: NgControl,
                @Optional() @Inject(TIME_MERIDIEM) private _meridiem?: boolean) {
        super(_element, changeRef, ngControl);

        this.pickerSelector = 'anj-datetime-picker';
    }

    ngAfterViewInit() {
        super.ngAfterViewInit();
        this.picker.setAttribute('meridiem', this._meridiem);
    }
}
